module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm._isColmo + 'checkbox',
    class: [
      'dof-cell',
      !_vm.disabled && 'active-cell',
      _vm.hasTopBorder && 'cell-top-border',
      _vm.hasBottomBorder && 'cell-bottom-border',
      _vm.disabled && 'checkbox-disabled'
    ],
    style: _vm.cellDynamicHeight,
    on: {
      "click": _vm.dofCellClick
    }
  }, [(!_vm._isColmo) ? _c('image', {
    class: ['checkbox', _vm.disabled && 'checkbox-icon-disabled'],
    attrs: {
      "slot": "value",
      "src": _vm.checkIcon
    },
    slot: "value"
  }) : _vm._e(), (_vm._isColmo) ? _c('div', {
    staticClass: ["circle"],
    style: {
      backgroundColor: _vm.innerChecked ? '#b35336' : 'transparent',
      borderColor: _vm.innerChecked ? 'transparent' : '#797979'
    },
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [(_vm.innerChecked) ? _c('dof-iconfont', {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      "code": '\u4729',
      "size": 40,
      "color": 'rgba(255, 255, 255, 0.8)'
    }
  }) : _vm._e()], 1) : _vm._e(), (_vm.itemImg && _vm.itemImg != '') ? _c('div', {
    staticClass: ["avatar"]
  }, [(_vm.itemImg && _vm.itemImg != '') ? _c('image', {
    staticClass: ["item-img"],
    attrs: {
      "src": _vm.itemImg
    }
  }) : _vm._e()]) : _vm._e(), _c('div', {
    class: [
      'main-wrapper',
      _vm.hasSubTopBorder && 'checkBox-top-border',
      _vm.itemImg && _vm.hasSubBottomBorder && 'checkBox-bottom-border'
    ],
    style: _vm.dynamicSizeComp
  }, [_c('div', {
    staticClass: ["content-title"],
    style: _vm.titleDynamicHeight
  }, [_c('div', {
    staticClass: ["cell-title"]
  }, [_c('text', {
    ref: "titleBox",
    class: ['title-text', _vm.isOverflow && 'title-flex-expand'],
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.tag) ? _c('text', {
    ref: "tagBox",
    staticClass: ["cell-title-btn"]
  }, [_vm._v(_vm._s(_vm.tag))]) : _vm._e()]), (_vm.desc) ? _c('div', {
    staticClass: ["sub-title"]
  }, [_c('text', {
    staticClass: ["sub-text"],
    attrs: {
      "slot": "sub-text"
    },
    slot: "sub-text"
  }, [_vm._v(_vm._s(_vm.desc))])]) : _vm._e()]), (_vm.hasArrow) ? _c('dof-image', {
    staticClass: ["cell-arrow-icon"],
    attrs: {
      "src": _vm.ARROW_ICON
    }
  }) : _vm._e()], 1), (!_vm.itemImg && _vm.hasSubBottomBorder) ? _c('div', {
    staticClass: ["fakeSubBorder"]
  }) : _vm._e(), (_vm._isDiablo && _vm.disabled) ? _c('div', {
    staticClass: ["disabledMask"]
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-5662659c!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-checkbox/index.vue
// module id = 608
// module chunks = 0 1